import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Card, Form, Modal, Spin, notification } from 'antd';

import Button from 'components/Button';
import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { FinAssetResponse } from 'services/finassets';
import ParListSelect from 'components/ParListSelect';
import {
  dateToString,
  indexBy,
  setValueByNamePath,
  shouldUpdateCompare,
} from 'utils/utils2';
import { useForm } from 'antd/lib/form/Form';
import Value from 'components/Value';
import { findFinCTByAnyRefOrStatusOrDate } from 'services/fincontract';
import moment from 'moment';
import { isNil, sumBy } from 'lodash';
import {
  AssetRVCriteria,
  AssetUseCriteria,
  FilteringCriteria,
  getprOfferDetailByOfferId,
  getprOfferListByPrcodeAndMgid,
  prFilteringCriteria,
} from 'services/pricing';
import getEnvValue from 'utils/getEnvValue';
import { request } from 'utils/request';
import { API_URLS } from 'utils/config';
import { toCurrency } from 'utils/utils';

type BrokerModalProps = {
  onCancel: () => void;
  visible: boolean;
  title: string;
  onSuccess: () => void;
  listAsset: any[];
  task: any;
  assetclass: any;
};

const ConversionAssetModal = (props: BrokerModalProps) => {
  const { onCancel, onSuccess, visible, title, listAsset, task, assetclass } =
    props;
  const [loading, setLoading] = useState<any>(false);

  const [form] = useForm();

  const [selectedClass, setSelectedClass] = useState<string>('');

  const [objectList, setObjectList] = useState<any[]>([]);

  const fieldname = 'assets';

  const getName = useCallback(
    (name: string) => (record: any) => {
      const assets = form.getFieldValue('assets');
      const index = indexBy(assets, 'assetid')[record.assetid];
      return [fieldname, index, name];
    },
    [form]
  );

  const object = {
    entity: 'CONTRACT',
    entityId: '',
    objectreference: '',
    ctrid: '',
    effectDate: '',
    newEndDate: '',
    lastInvoiceDate: '',
    ctFinancedAmount: '',
    newCtFinancedAmount: '',
    newNominalRate: '',
    newRateSpread: '',
    newRateRef: '',
    newRateFormula: '',
    newRateType: '',
    newPeriodicity: '',
    newDuration: '',
    feesFormula: '',
    feesAmount: '',
    mode: '', // CALCUL, REAL
    modid: '',
    taskid: '',
    flagUpdateAuthorization: '',
    comment: '',
    modreason: '',
    offerid: '',
    old_offerid: '',
    finassetrequestlist: '',
  };

  const getContract = (ctrid: number) => {
    return findFinCTByAnyRefOrStatusOrDate({
      branchid: 0,
      brokername: '',
      clientname: '',
      ctphase: '',
      ctstatus: '',
      datemax: '',
      datemin: '',
      marketingid: 0,
      network: '',
      offerid: 0,
      prcode: '',
      ctreference: '',
      propreference: '',
      tpidbroker: 0,
      tprefbroker: '',
      clientreference: '',
      tpreference: '',
      ctrid: ctrid,
      tpidsupplier: 0,
    }).then((res) => {
      if (res?.list?.length > 0) {
        return res?.list[0];
      }
    });
  };
  useEffect(() => {
    if (listAsset.length > 0) {
      form.setFieldsValue({
        assets: listAsset ?? [],
      });

      const newAssetsList: any[] = [];
      Promise.all(
        listAsset.map(async (finAsset) => {
          let contract = await getContract(finAsset.ctrid);
          if (contract) {
            newAssetsList.push({
              entity: 'CONTRACT',
              entityId: contract?.ctrid,
              objectreference: contract?.ctreference,
              ctrid: contract?.ctrid,
              effectDate: moment().format('YYYY-MM-DD'),
              newEndDate: '',
              newNominalRate: '',
              newRateSpread: '',
              newRateRef: '',
              newRateFormula: '',
              newRateType: '',
              newPeriodicity: '',
              newDuration: '',
              feesFormula: '',
              feesAmount: '',
              mode: 'SIMUL', // CALCUL, REAL
              modid: '',
              taskid: task.taskid,
              flagUpdateAuthorization: '',
              comment: '',
              modreason: '',
              offerid: '',
              old_offerid: contract?.offerid,
              finassetrequestlist: [],
              ctFinancedAmount: contract?.ctfinancedamount,
              newCtFinancedAmount: contract?.ctfinancedamount,
              ctactivationdate: contract.ctactivationdate,
              startDate: contract.ctactivationdate,
              newStartDate: !isNil(contract.ctactivationdate)
                ? contract.ctactivationdate
                : moment().format('YYYY-MM-DD'),
              lastInvoiceDate: '',
              assetid: finAsset.assetid,
              assetreference: finAsset.assetreference,
              assetlabel: finAsset.assetlabel,
              assetnetamount: finAsset.assetnetamount,
              assetrvamount: finAsset.assetrvamount,
              targetclass: '',
              chassisno: finAsset?.chassisno,
            });
          }
        })
      ).then((res) => {
        form.setFieldsValue({
          assets: newAssetsList ?? [],
        });
      });
    } else {
      form.setFieldsValue({
        assets: [],
      });
    }
  }, [listAsset]);

  const getFilterList = (assets: any): prFilteringCriteria => {
    let assetList = assets;

    let assetUseCriteriaList: Array<AssetUseCriteria> = [];
    let assetRVCriteriaList: Array<AssetRVCriteria> = [];
    let offerCriteriaList: Array<FilteringCriteria> = [];
    let ret: prFilteringCriteria;

    offerCriteriaList.push({
      critcode: 'PROPORIGIN',
      critvalue: form?.getFieldValue('ctproporigin') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'DEALRATING',
      critvalue: form?.getFieldValue('ctdealerrating') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'OFFER',
      critvalue: form?.getFieldValue('offerid') ?? '0',
    });
    offerCriteriaList.push({
      critcode: 'NASSETS',
      critvalue: form?.getFieldValue('assets')?.length ?? '0',
    });

    const duration = form
      ?.getFieldValue(['elements', 'FIN'])
      ?.filter(
        (e: any) => e.cteid === form?.getFieldValue('selectedElement')
      )[0]?.cteduration;

    offerCriteriaList.push({
      critcode: 'DURATION',
      critvalue: duration ?? 48,
    });

    const invest = sumBy(form?.getFieldValue('assets'), 'assetnetamount');

    offerCriteriaList.push({
      critcode: 'INVEST',
      critvalue: String(invest) ?? '0',
    });

    //PROPORIGIN

    offerCriteriaList.push({
      critcode: 'PRCODE',
      critvalue: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'TPTYPE',
      critvalue: form.getFieldValue('client')?.tptype ?? '',
    });
    offerCriteriaList.push({
      critcode: 'NETWORK',
      critvalue: form.getFieldValue('ctnetworkcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'CLIRATING',
      critvalue: form.getFieldValue('client')?.tpsalestatus ?? '',
    });

    assetList?.forEach((a: any) => {
      assetRVCriteriaList.push({
        catalogid: a.catalogid,
        assetid: a.assetid,
        assetsegment: a.assetsegment,
        assetfamily: a.assetfamily,
        assettype: a.assettype,
        assetcategory: a.assetcategory,
        assetmodel: a.assetmodel,
        assetbrand: a.assetbrand,
        assetbrandmodel: a.assetbrandmodel,
        assetnetamount: a.assetnetamount,
        assetfinamount: a.assetfinamount,
        assetvariant: a.assetvariant,
        // assetclass :a.assetclass,
      });

      offerCriteriaList.push({
        critcode: 'ASSETFAM',
        critvalue: a.assetfamily,
      });
      offerCriteriaList.push({ critcode: 'ASSETTYPE', critvalue: a.assettype });
      offerCriteriaList.push({
        critcode: 'ASSETCAT',
        critvalue: a.assetcategory,
      });

      offerCriteriaList.push({
        critcode: 'FLAGUSED',
        critvalue: a.flagused ?? '',
      });

      offerCriteriaList.push({
        critcode: 'ASSETCLASS',
        critvalue: a.targetclass ?? '',
      });

      a.power != null ??
        offerCriteriaList.push({ critcode: 'POWER', critvalue: a.power ?? '' });
      // additional attributes :
      a.entityAddAttributList?.forEach((e: any) => {
        e.attstringvalue !== null
          ? offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attstringvalue,
            })
          : e.attnumericvalue !== null ??
            offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attnumericvalue,
            });
      });

      if (getEnvValue('FLAG_APPLY_ASSET_USE')) {
        a.assetusereqList?.forEach((u: any) => {
          assetUseCriteriaList.push({
            assetfamily: a.assetfamily,
            assettype: a.assettype,
            assetcategory: a.assetcategory,
            catalogid: a.catalogid ?? '',
            attcode: u.attcode ?? '',
            attvalue: u.usevalue ?? '',
          });
        });
      }
    });

    ret = {
      prcode: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
      tpid: form.getFieldValue('client')?.tpid ?? 0,
      tpidbroker: form.getFieldValue('broker')?.tpid ?? 0,
      tpidmanufacturer:
        assetList && assetList.length > 0
          ? assetList![0]?.tpidmanufacturer ?? 0
          : 0,
      assetUseCriteria: assetUseCriteriaList,
      assetRVCriteria: assetRVCriteriaList,
      offerCriteria: offerCriteriaList,
      flagApplyAssetUse: getEnvValue('FLAG_APPLY_ASSET_USE'),
      flagApplyAttributesExtendDurationValues: true,
      flagApplyAttributesExtendFirstRentalValues: true,
      flagApplyAttributesExtendRVValues: true,
      flagApplyAttributesExtendRateValues: true,
      flagApplyExtendDurationValues: true,
      flagApplyExtendFirstRentalValues: true,
      flagApplyExtendRVValues: true,
      flagApplyExtendRateValues: true,
    };
    return ret;
  };

  const handleOfferChange = (offerid: any, asset: any) => {
    const assets = Array(asset);
    //// get offer
    setLoading(true);

    getprOfferDetailByOfferId({
      offerid: offerid,
      filtersList: getFilterList(assets),
    })
      .then((res: any) => {
        setLoading(false);

        if (res.data != null) {
          try {
            let startdate = form.getFieldValue('newStartDate') ?? moment();
            var init = moment(dateToString(startdate));
            var target = init
              .add(form.getFieldValue('newDuration'), 'M')
              .subtract(1, 'd');
          } catch (error) {
          }

          /// update asset Object
          const listOfAsset = form.getFieldValue('assets');

          const newlistOfAsset: any[] = [];

          listOfAsset.forEach((_asset: any, i: number) => {
            if (asset.assetid === _asset.assetid) {
              newlistOfAsset.push({
                ..._asset,
                newDuration: res.data.durationdefault,
                newPeriodicity: res.data.prefinperiodicity,
                newCalculationtype: res.data.prefinmethod,
                newRatetype: res.data.prefinratetype,
                newRateformula: res.data.prefinrateformula,
                newRateRef: res.data.prefinrateref,
                newRateSpread: res.data.prefinratespreaddefault,
                newNominalRate: res.data.prefinnominalrate,
                comment:
                  asset.chassisno +
                  ' - ' +
                  (assetclass === 'DC'
                    ? 'Demonstration Car'
                    : assetclass === 'UC'
                    ? 'Used Car'
                    : 'New Vehicle') +
                  ' To ' +
                  (asset.targetclass === 'DC'
                    ? 'Demonstration Car'
                    : asset.targetclass === 'UC'
                    ? 'Used Car'
                    : 'New Vehicle') +
                  ' - ' +
                  asset.assetlabel,
                modreason: '',
                offerid: offerid,
                offerlabel: res.data.offerlabel ?? 'no offer',
              });
            } else {
              newlistOfAsset.push(_asset);
            }
          });

          form.setFieldValue('assets', newlistOfAsset);

          setObjectList(newlistOfAsset);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const sendRequest = () => {
    setLoading(true);
    const [url, paramsString] = task.serviceurl
      ? task.serviceurl.split('?')
      : ''.split('?');

    objectList.forEach((Obj) => {
      const requestToSend = {
        ...Obj,
        finassetrequestlist: [
          {
            assetid: Obj.assetid,
            assetreference: Obj.assetreference,
            assetlabel: Obj.assetlabel,
            assetnetamount: Obj.assetnetamount,
            assetrvamount: Obj.assetrvamount,
            targetclass: Obj.targetclass,
          },
        ],
      };
      request
        .post(`${API_URLS.WORKFLOW}/api/${url}`, requestToSend)
        .then((res) => {
          setLoading(false);
          if (res.success) {
            notification.success({ message: res.message });
          } else {
            return Promise.reject(res);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    });

    // setload(true);
  };

  const columns = useMemo<DataGridColDef<FinAssetResponse>[]>(
    () => [
      {
        dataIndex: 'assetreference',
        width: 200,
        render: (value, record) => (
          <Form.Item noStyle name={getName('assetreference')(record)}>
            <Value />
          </Form.Item>
        ),
      },
      {
        dataIndex: 'assetlabel',
        width: 200,
        render: (value, record) => (
          <Form.Item noStyle name={getName('assetlabel')(record)}>
            <Value />
          </Form.Item>
        ),
      },
      {
        dataIndex: 'assetnetamount',
        width: 200,
        render: (value, record) => (
          <Form.Item noStyle name={getName('assetnetamount')(record)}>
            <Value formatter={toCurrency} />
          </Form.Item>
        ),
      },
      {
        dataIndex: 'assetrvamount',
        width: 'hide',
        render: (value, record) => (
          <Form.Item noStyle name={getName('assetrvamount')(record)}>
            <Value />
          </Form.Item>
        ),
      },
      {
        dataIndex: 'finrvamount',
        width: 130,
        render: (value, record) => (
          <Form.Item noStyle name={getName('finrvamount')(record)}>
            <Value />
          </Form.Item>
        ),
      },
      {
        dataIndex: 'targetclass',
        width: 200,
        render: (value, record) => (
          <Form.Item noStyle name={getName('targetclass')(record)}>
            <ParListSelect
              onChange={(e) => {
                setLoading(true);
                setValueByNamePath(form, getName('targetclass')(record), e);
                getprOfferListByPrcodeAndMgid({
                  filters: getFilterList(Array({ ...record, targetclass: e })),
                })
                  .then((res) => {
                    setLoading(false);

                    if (res.list.length > 0) {
                      let offer = res.list[0];
                      handleOfferChange(offer.offerid, {
                        ...record,
                        targetclass: e,
                      });
                    }
                  })
                  .catch(() => {
                    setLoading(false);
                  });
              }}
              parcode="ASSETCLASS"
              style={{ width: '100%' }}
            />
          </Form.Item>
        ),
      },

      {
        dataIndex: 'offerlabel',
        width: 200,
      },
    ],
    []
  );

  return (
    (<DF.Provider pagcode="proplist">
      <Modal
        open={visible}
        onCancel={onCancel}
        width={1400}
        title={title}
        footer={[
          <Button
            key="exec"
            comcode="exec"
            disabled={objectList?.length === 0}
            onClick={() => {
              sendRequest();
            }}
            type="primary"
          />,
          <Button key="cancel" comcode="cancel" onClick={onCancel} />,
        ]}
      >
        <Spin spinning={loading}>
          <Card>
            <Form form={form}>
              <Form.Item noStyle shouldUpdate={shouldUpdateCompare('assets')}>
                {({ getFieldValue }) => {
                  return (
                    <DataGrid
                      columns={columns}
                      dataSource={form.getFieldValue('assets')}
                      pagination={false}
                    />
                  );
                }}
              </Form.Item>
            </Form>
          </Card>
        </Spin>
      </Modal>
    </DF.Provider>)
  );
};

export default ConversionAssetModal;
